import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate from react-router-dom
import axios from "axios";
import "remixicon/fonts/remixicon.css";

export default function Contact1() {
  const navigate = useNavigate(); // Initialize useNavigate
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      const response = await axios.post(
        "http://127.0.0.1:8000/contact/contact/",
        {
          name: formData.name,
          email: formData.email,
          message: formData.message,
        }
      );
      setSuccessMessage("Message sent successfully!");
      setFormData({ name: "", email: "", message: "" });
      setTimeout(() => navigate("/"), 2000); // Redirect to home page after 2 seconds
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message || "Failed to send message. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-300 w-full h-full">
      <div className="px-6 md:px-8 mx-auto pt-[6rem] pb-4">
        <div className="bg-white rounded-3xl min-h-[600px] flex flex-col lg:flex-row shadow-md relative">
          {/* Cross Button */}
          <button
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-2xl"
            onClick={() => navigate("/")}
          >
            <i className="ri-close-line"></i>
          </button>

          {/* Left Section */}
          <div className="flex-1 mx-auto px-14 md:px-24 md:pr-36 w-[100%] max-w-[84rem] pt-4">
            <div className="flex flex-col gap-4 mt-16">
              <div className="text-black text-base flex flex-row items-center gap-3">
                <i className="ri-circle-fill text-purple-500"></i>
                <h1 className="font-bold text-lg">Get to Know Us Better</h1>
              </div>
              <div className="text-4xl md:text-6xl font-light text-black">
                <h1>
                  <b>Let's connect</b>
                </h1>
              </div>
              <div className="max-w-[32rem] text-black text-base md:text-[18px] font-normal mt-2">
                <p>
                  Contact us today to explore opportunities, get assistance, or
                  simply say hello!
                </p>
              </div>
              <div className="flex flex-col gap-1">
                <div className="text-black text-base md:text-[18px] font-normal mt-2">
                  <h1 className="font-semibold">Email Us</h1>
                  <div className="flex flex-row gap-2 mb-2">
                    <div className="text-gray-700 text-xl p-2 bg-gray-200 rounded-xl">
                      <i className="ri-arrow-right-up-line"></i>
                    </div>
                    <div className="md:text-lg text-base font-medium text-black p-3 bg-gray-200 rounded-xl">
                      <a
                        href="mailto:info@Luytens.com"
                        className="cursor-pointer"
                      >
                        info@Jobgenee.com
                      </a>
                    </div>
                  </div>
                </div>
                <div className="text-black text-base md:text-[18px] font-normal mt-2">
                  <h1 className="font-semibold">Call Us on</h1>
                  <p>+91 1203507027,</p>
                  <p>+1 6093160709</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section (Contact Form) */}
          <div className="flex-1 mx-auto px-14 md:px-24 md:pr-36 w-[100%] max-w-[84rem] pt-4 justify-center items-center flex">
            <div className="w-full">
              <form className="space-y-4" onSubmit={handleSubmit}>
                <div>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your name"
                    className="w-full px-4 py-3 border text-black rounded-xl focus:outline-none focus:ring-1 focus:ring-purple-500 bg-gray-200"
                  />
                </div>
                <div>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    className="w-full px-4 py-3 border text-black rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 bg-gray-200"
                  />
                </div>
                <div>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Type your message here"
                    className="w-full px-4 py-3 border text-black rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 bg-gray-200"
                  ></textarea>
                </div>

                {loading ? (
                  <button
                    type="button"
                    disabled
                    className="md:text-lg w-[10rem] text-base font-medium text-white bg-gray-400 p-3 rounded-xl"
                  >
                    Sending...
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="md:text-lg w-[10rem] text-base font-medium text-white bg-purple-500 hover:bg-purple-700 p-3 rounded-xl transition-all duration-300"
                  >
                    Send Message
                  </button>
                )}
              </form>
              {successMessage && (
                <p className="text-green-500 mt-4">{successMessage}</p>
              )}
              {errorMessage && (
                <p className="text-red-500 mt-4">{errorMessage}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
